// extracted by mini-css-extract-plugin
export var pillWrapper = "_jx-0";
export var showOverflow = "_jx-1";